import { render, staticRenderFns } from "./StatisticsTrendsDetails.vue?vue&type=template&id=f8e3de8c&scoped=true"
import script from "./StatisticsTrendsDetails.vue?vue&type=script&lang=ts"
export * from "./StatisticsTrendsDetails.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsTrendsDetails.vue?vue&type=style&index=0&id=f8e3de8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e3de8c",
  null
  
)

export default component.exports